import { Card } from "@amzn/stencil-react-components/dist/submodules/card";
import { Col, Row, View } from "@amzn/stencil-react-components/layout";
import { Text } from "@amzn/stencil-react-components/text";
import IconDesktop from "@amzn/stencil-react-icons/icons/icon-desktop";
import IconGrowth from "@amzn/stencil-react-icons/icons/icon-growth";
import IconQuestionCircle from "@amzn/stencil-react-icons/icons/icon-question-circle";
import { IconSize } from "@amzn/stencil-react-icons/icons/interfaces";
import { Paths } from "common/paths/paths";
import { getString } from "common/uistringlabels/uiStringUtils";
import React from "react";

import laptopIcon from "../../../../public/img/laptop-icon.svg";
import HardwareLink from "./HardwareLink";

// TODO: Determine ticket url based on user country. ITMP: https://issues.amazon.com/issues/ITMP-1938
const simUrlLatam = "https://t.corp.amazon.com/create/templates/bb1114a6-a248-4e28-b475-0128cf33ca12";

const HardwareSupportWidget = (): React.JSX.Element => {
  return (
    <Card width={450} padding={{ top: "S400", bottom: "S400", right: "S300", left: "S300" }}>
      <Col gridGap={"S200"} padding={{ left: "S200" }}>
        {/* Title */}
        <Row padding={{ left: "S200", right: "S200" }}>
          <Text fontWeight={"bold"} fontSize={"T300"}>
            {getString(`hardwareSupportWidget.title`)}
          </Text>
        </Row>

        {/* Links */}
        <Col gridGap={0} data-test-id="hardware-support-links">
          <HardwareLink
            icon={<IconQuestionCircle color="neutral90" size={IconSize.Small} />}
            text={getString(`hardwareSupportWidget.getHelpWithLaptop`)}
            touchpointId="get-help-with-laptop"
            link={"https://my.it.a2z.com/search?query=laptop%20issue&filters=ITPortal&language=en"}
          />
          <HardwareLink
            icon={<IconGrowth color="neutral90" size={IconSize.Small} />}
            text={getString(`hardwareSupportWidget.checkElegibility`)}
            touchpointId="check-eligibility"
            description={getString(`hardwareSupportWidget.checkElegibilityDescription`)}
            link={"https://my.it.a2z.com/articles/hardware/laptop/request-a-laptop"}
          />
          <HardwareLink
            icon={
              <View display="flex" alignItems="center">
                <img src={laptopIcon} alt="My Icon" />
              </View>
            }
            text={getString(`hardwareSupportWidget.requestUpgrade`)}
            internalNav={true}
            touchpointId="request-upgrade"
            link={Paths.hardwareSearch.url}
          />
          <HardwareLink
            icon={<IconDesktop color="neutral90" size={IconSize.Small} />}
            text={getString(`hardwareSupportWidget.requestMonitor`)}
            touchpointId="request-monitor"
            link={simUrlLatam}
          />
        </Col>
      </Col>
    </Card>
  );
};

export default HardwareSupportWidget;
